import { useSelector } from 'react-redux';
import FJAppConstant from '../constants/FJAppConstant';
import FJConfig from '../config/FJConfig.js';
import FJTextBasedEditingConfig from '../config/appConfig/FJTextBasedEditingConfig.js';

const useDefaultFreeLimit = freeLimitType => {
    const defaultFreeLimitInfo = useSelector(state => state.common.defaultFreeLimitInfo);
    const appType = useSelector(state => state.common.appType);

    const getDataList = () => {
        switch (appType) {
            case FJAppConstant.AI_VIDEO_GENERATOR: {
                // const ivFreeNum = defaultFreeLimitInfo['image-to-video'];
                // const tvFreeNum = defaultFreeLimitInfo['text-to-video'];
                return {
                    defaultFreeNumCreation: defaultFreeLimitInfo[freeLimitType],
                };
            }
            case FJAppConstant.AI_AUDIO_GENERATOR: {
                // 更新 T2M 免费次数
                // info['text-to-music'];
                // info['text-to-accompany'];
                // 更新 M2M 免费次数
                // info['music-generator'];
                // info['audio-accompany-generator'];
                // SFX
                // info['audio-effect-generator'];
                return {
                    defaultFreeNumCreation: defaultFreeLimitInfo[freeLimitType],
                };
            }
            case FJAppConstant.OBJECT_ERASER: {
                // info[FJObjectEraseConfig.freeLimitType];
                // info[FJObjectEraseConfig.promptRemovalFreeLimitType];
                return {
                    defaultFreeNumCreation: defaultFreeLimitInfo[freeLimitType],
                };
            }
            case FJAppConstant.PHOTO_REMOVE_BG: {
                // info[FJConfig.autoFreeLimitType]
                //  info[FJConfig.freeLimitType]
                return {
                    defaultFreeNumCreation: defaultFreeLimitInfo[freeLimitType],
                };
            }
            case FJAppConstant.VIDEO_REMOVE_BG: {
                // info[FJConfig.freeLimitType];
                // info[FJConfig.autoRemoverLimitType];
                return {
                    defaultFreeNumCreation: defaultFreeLimitInfo[freeLimitType],
                };
            }
            case FJAppConstant.TEXT_TO_SPEECH: {
                //info['text-to-audio']
                //info['fish-speech']
                return {
                    defaultFreeNumCreation: defaultFreeLimitInfo[freeLimitType],
                };
            }
            case FJAppConstant.TEXT_TO_FULL_VIDEO:
            case FJAppConstant.BLOG_URL_TO_VIDEO:
            case FJAppConstant.PRODUCT_URL_TO_VIDEO:
            case FJAppConstant.PPT_TO_VIDEO: {
                // const freeNumCreationInfo = {
                //     textToScript: info[TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.TEXT_TO_SCRIPT] || 0,
                //     analysisUrl: info[TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.ANALYSIS_URL] || 0,
                //     textToFullVideo: info[TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.TEXT_TO_FULL_VIDEO] || 0,
                //     productUrlToVideo: info[TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.PRODUCT_URL_TO_VIDEO] || 0,
                //     blogUrlToVideo: info[TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.BLOG_URL_TO_VIDEO] || 0,
                //     pptToVideo: info[TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.PPT_TO_VIDEO] || 0,
                // };
                return {
                    defaultFreeNumCreation: defaultFreeLimitInfo[freeLimitType],
                };
            }

            case FJAppConstant.AI_TEXT_BASED_EDITING: {
                return {
                    defaultFreeNumCreation: defaultFreeLimitInfo[FJTextBasedEditingConfig.freeLimitHighlightType],
                };
            }
            default:
                return { defaultFreeNumCreation: defaultFreeLimitInfo[FJConfig.freeLimitType] || 0 };
        }
    };

    const { defaultFreeNumCreation } = getDataList();

    return defaultFreeNumCreation;
};

export default useDefaultFreeLimit;
